import { Menu } from "@headlessui/react"
import Svg from "./svg"
import { useState } from "react"
import Button from "@common/buttons/button"
import { joinClassNames } from "./lib/util"
/**
  ⭐ @example
  options = [
  {key: 'sentiment', display: 'Sentiment', icon: 'delete', disabled:true},
  {key: 'rencent', display: 'Recent', icon: 'edit',disabled:false},
  {key: 'popular', display: 'Popular'},
 */

export default function MenuStyled({
  options,
  onOptionClick,
  buttonTextOverride,
  buttonOverride,
  optionWidth,
  position = "right",
}) {
  const [selected, setSelected] = useState(options[0])

  return options.length == 1 ? (
    <Button
      disabled={selected["disabled"]}
      disabledMsg={selected["disabledMsg"]}
      variant={"outline"}
      onClick={(e) => handleClick(selected, e)}
    >
      <Svg name={selected["icon"] || "delete"} classes="h-5 w-5 mr-2" />
      {selected["display"]}
    </Button>
  ) : (
    <div className="relative  text-left flex" onClick={(e) => e.stopPropagation()}>
      <Menu>
        {({ open }) => (
          <>
            {buttonOverride ? (
              <Menu.Button className="focus:outline-none z-20 ">
                {buttonOverride}
              </Menu.Button>
            ) : (
              <span className="rounded-md shadow-sm z-20 ">
                <Menu.Button className="menu-button">
                  <span>{buttonTextOverride || selected["display"]}</span>
                  <Svg
                    name="arrow-down-menu"
                    classes="w-5 h-5 ml-2 -mr-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    stroke="none"
                  />
                </Menu.Button>
              </span>
            )}

            {open && (
              <Menu.Items
                static
                className={joinClassNames(
                  "menu-items z-30 top-7 animate-slideDown",
                  optionWidth ? optionWidth : "",
                  position == "right" ? "right-0" : "left-0"
                )}
              >
                <div className="p-1">
                  {options.map((option, index) => {
                    const { disabled } = option
                    return (
                      <div key={index}>
                        <Menu.Item disabled={disabled}>
                          {({ active }) => (
                            <button
                              onClick={(ev) => handleClick(option, ev)}
                              className={`${
                                active ? "menu-item-active" : "menu-item-inactive"
                              } menu-item`}
                            >
                              <div className="flex items-center">
                                <div>
                                  {"icon" in option ? (
                                    <Svg
                                      name={option["icon"]}
                                      classes={"mr-3 h-4 w-4"}
                                    />
                                  ) : null}
                                </div>
                                <div>{option["display"]}</div>
                              </div>
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    )
                  })}
                </div>
              </Menu.Items>
            )}
          </>
        )}
      </Menu>
    </div>
  )

  function handleClick(selected, ev) {
    setSelected(selected)
    if (onOptionClick) onOptionClick(selected, ev)
  }
}
